<div class="local-audio-player">
  <button mat-icon-button class="eiq-button" [@rotateInOut]="paused$() ? 'true' : 'void'" (click)="onPlayPause()">
    @if (!paused$()) {
      <fa-icon [icon]="faPause"></fa-icon>
    } @else {
      <fa-icon [icon]="faPlay" class="local-audio-player__actions-button__play"></fa-icon>
    }
  </button>
  <div class="local-audio-player__audio">
    <div #localAudioPlayer [id]="'audio_' + id"></div>
  </div>
</div>
